export class TemplateSendPreviewModel {
  public templateId: number;
  public email: string;
  public companyId: number;
  public language: number;

  public html: string;
}

